import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AppService, private router: Router) {}

  async canActivate() {
    const status = await this.authService.isLoggedIn();
    if (status) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot,
  // ): boolean | UrlTree {
  //   // alert(`URL: ${state.url}`);
  //   this.auth.setRedirectUrl(state.url);
  //   if (this.auth.isLoggedIn()) {
  //     return true;
  //   } else {
  //     return this.router.createUrlTree(['/login']);
  //   }
  // }
}
